/* eslint-disable */
import { APIComplaintRider, APIGetOrdersSupplement, APIAddUpdateOrdersSupplement, APIGetOrderInfo, APIGetMatterOrderStatus, APISendFailedMatterOrder } from '@/apis/APIOrder.js'
import { json2query } from '@/utils'
import api from '@/utils/api.js'
import msgWarning from '@/tools/msgwarning.js'
import { hideLoad } from '@/tools/loading.js'
/**
 * 查询订单全能接口 get /order/GetOrders
 * keyword     str
 * fromDate    str 2018-07-18
 * toDate      str
 * vendorID    int
 * storeIDs    str 京西门店ID列表 []
 * statuss     str 订单状态列表 [10, 15, 20, 110, 105, 115, 120]
 * cities      str 城市列表 []
 * offset
 * pageSize
 */
export const apiGetOrder = async (json,noLoading = true) => {
  try {
    let res = await api('v2/order/GetOrders', {
      params: json,
      noLoading
    })
    return res
  } catch (e) {
    throw e
  }
}

/**
 * 获取售后单信息
 */
 export const apiGetAfsOrders = async (query, noLoading = true) => {
  try {
    let res = await api('v2/order/GetAfsOrders', {
      params: query,
      noLoading
    })
    return res
  } catch (e) {
    console.error('GetOrders', e)
    throw e
  }
}

/**
 * 补充评价订单号
 * userName
 * appOrgCode 菜市：589/5873  果园：4123
 * fromTime
 * toTime
 */
// https://www.jxc4.com/v2/store/GetOrderID4Comment?userName=jxcaishi_cookie&appOrgCode=5873&fromTime=2024-07-25&toTime=2024-08-04
export const apiGetOrderID4Comment = async (query,noLoading = true) => {
  try {
    let res = await api('v2/store/GetOrderID4Comment', {
      params: query,
      noLoading
    })
    return res
  } catch (error) {
    console.error('GetOrders', e)
    throw e
  }
}

// 投诉骑手(三方运送)
// token                     string         true "认证token"
// vendorOrderID                 string         true "订单号"
// vendorID int true "订单所属厂商ID"
// waybillVendorID int true "运单所属厂商ID"
// complaintID          int             true "投诉原因ID"
export const complainRider = async (json) => {
  try {
    await APIComplaintRider(json2query(json))
  } catch (e) {
    throw e
  }
}

// 重发京东物流
export const sendFailedMatterOrder = async (json) => {
  try {
    await APISendFailedMatterOrder(json2query(json))
  } catch (e) {
    throw e
  }
}
//修改配送信息
export const updateOrderInfo = async (json = {}) => {
  try {
    let { vendorOrderID, vendorID, payload } = json
    let form = new FormData()
    form.append('vendorOrderID', vendorOrderID)
    form.append('vendorID', vendorID)
    form.append('payload', payload)
    let res = await api('v2/order/UpdateOrderInfo', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: form,
    })
    return res
  } catch (e) {
    msgWarning(e)
  } finally {
    hideLoad()
  }
}
export const APIdelOrderSkuInfo = async (json = {}) => {
  try {
    let { vendorOrderID, vendorID, ID } = json
    let form = new FormData()
    form.append('vendorOrderID', vendorOrderID)
    form.append('vendorID', vendorID)
    form.append('ID', ID)
    let res = await api('v2/order/DelOrderSkuInfo', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: form,
    })
    return res
  } catch (e) {
    msgWarning(e)
  } finally {
    hideLoad()
  }
}
//刷新报价订单的订单商品
export const refreshOrderSkuInfo = async (json = {}) => {
  try {
    let { vendorOrderID, vendorID, skuID } = json
    let form = new FormData()
    form.append('vendorOrderID', vendorOrderID)
    form.append('vendorID', vendorID)
    form.append('skuID', skuID)
    let res = await api('v2/order/RefreshOrderSkuInfo', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      data: form,
    })
    return res
  } catch (e) {
    msgWarning(e)
  } finally {
    hideLoad()
  }
}
// 查询门店订单扣款记录
/*
storeIDs	门店ID列表
vendorOrderID	订单ID
vendorIDs	订单所属厂商ID列表
fromTime	开始日期（包含），格式（2006-01-02），如果订单号为空此项必须要求
toTime	结束日期（包含），格式（2006-01-02），如果订单号为空此项必须要求
status	账单状态，0是未结账，1是已结账
type	扣款类型，1为差评补贴，2为优惠券
offset	结果起始序号（以0开始，缺省为0）
pageSize	结果页大小（缺省为50，-1表示全部 
*/
export const getOrdersSupplement = async (json, noLoading = true) => {
  try {
    let res = await APIGetOrdersSupplement(json, noLoading)
    return res
  } catch (e) {
    throw e
  }
}

// 新增/修改扣款记录
// payload
/* 
新增
storeID              int        
vendorOrderID     string     
vendorID           string    
type                   int //扣款类型，1为差评订单补贴，2为优惠券
linkID                 int //作为冲账标志关联某条扣款记录，若新增为某一记录的冲账，则此字段填那条记录的id
supplementFee int        //扣款金额
comment           string         //备注

----
修改
id			    int
createdAt            time 	
storeID                int        
vendorOrderID    string     
vendorID             string    
status                  int        //账单状态，若已结账则不允许再修改 ，暂时 0为未结账，1为已结账,-1为作废
linkID                   int        //作为冲账标志关联某条扣款记录
type                     int        //扣款类型，1为差评订单补贴，2为优惠券
supplementFee   int        //扣款金额
billID                   string     //账单ID，后期可能关联账单用
comment            string     //备注
*/
export const addUpdateOrdersSupplement = async (payload, noLoading = true) => {
  try {
    let res = await APIAddUpdateOrdersSupplement(json2query({
      payload: JSON.stringify(payload)
    }), noLoading)
    return res
  } catch (e) {
    throw e
  }
}

// 得到订单详情
// vendorOrderID
// vendorID
// refresh
export const getOrderInfo = async (json, noLoading = true) => {
  try {
    let res = await APIGetOrderInfo({
      ...json,
      refresh: false
    }, noLoading)
    return res
  } catch (e) {
    throw e
  }
}

export const getMatterOrderStatus = async (vendorOrderID) => {
  try {
    const res = await APIGetMatterOrderStatus({ vendorOrderID })
    return res || []
  } catch (e) {
    throw e
  }
}

/**
 * 添加小费
 * @param {*} vendorOrderID 订单号
 * @param {*} vendorID 厂商ID
 * @param {*} tipFee 小费
 */
export const updateOrderWaybillTip = async ({
  vendorOrderID,
  vendorID,
  tipFee
}) => {
  try {
    const res = await api('v2/order/UpdateOrderWaybillTip', {
      method: 'POST',
      data: json2query({
        vendorOrderID,
        vendorID,
        tipFee
      }),
      noLoading: true
    })
    return res
  } catch (e) {
    throw e
  }
}
export const updateOrderWaybillDesiredFee = async ({
  vendorOrderID,
  desiredFee,
}) => {
  let formData = new FormData()
  formData.append('vendorOrderID', vendorOrderID)
  formData.append('desiredFee', desiredFee)
  try {
    const res = await api('v2/order/UpdateWaybillDesiredFee', {
      method: 'PUT',
      data: formData,
      noLoading: true
    })
    return res
  } catch (e) {
    throw e
  }
}
//刷新京东商城收货人信息
export const refreshReceiveManInfo = async (vendorOrderID) => {
  let formData = new FormData()
  formData.append('vendorOrderID', vendorOrderID)
  try {
    const res = await api('v2/order/RefreshJdsOrderConsigneeInfo', {
      method: 'PUT',
      data: formData,
      noLoading: true
    })
    return res
  } catch (e) {
    throw e
  }
}
//售前删除
export const delBeforeSale = async (skuID, vendorOrderID) => {
  let formData = new FormData()
  formData.append('vendorOrderID', vendorOrderID)
  formData.append('skuID', skuID)
  try {
    const res = await api('v2/order/AdjustJdsOrderSimple', {
      method: 'POST',
      data: formData,
      noLoading: true
    })
    return res
  } catch (e) {
    throw e
  }
}

/*
  得到订单sku信息 get /order/GetOrderSkuInfo
  vendorOrderID     str 订单ID
  vendorID          int 订单所属厂商ID
*/
export const getOrderSkus = async (vendorOrderID,vendorID, noLoading = true) => {
  try {
    let res = await api('v2/order/GetOrderSkuInfo', {
      params: {
        vendorOrderID,
        vendorID
      },
      noLoading
    })
    return res
  } catch (e) {
    console.error('SendFailedMatterOrder', e)
    throw e
  }
}

/**
 * @description 扫码枪 京西门店订单扫码枪扫码支付 post
 * @Param token           header    string  true "认证token"
 * @Param vendorOrderID   formData  string  true "订单ID"
 * @Param paymentLabel    formData  string  true "支付身份标示"
 * 
 * @Param	payType			    formData	string	true	"扫码方式[tonglian/lakala]"
 * 
 */
export const pay4OrderByBarCodeScanner =async (vendorOrderID,paymentLabel,noLoading = false) => {
  try {
    let form = new FormData()
    form.append('vendorOrderID', vendorOrderID)
    form.append('paymentLabel', paymentLabel)
    form.append('payType', 'lakala')
    let res = await api('v2/jxorder/Pay4OrderByBarCodeScanner', {
      method: 'POST',
      data: form,
      noLoading
    })
    if(res.includes('该终端不存在，请进行新增操作')){
      throw res
    }else {
      return res
    }
  } catch (e) {
    console.error('pay4OrderByBarCodeScanner', e)
    throw e
  }
}

/**
 * @description 扫码枪 手动刷新扫码枪扫码支付订单状态 post
 * @Param token           header    string  true   "认证token"
 * @Param vendorOrderID   formData  string  true   "订单ID"
 * @Param	payType			    formData	string	true	"扫码方式[tonglian/lakala]"
 * 
 */
export const refreshPayStatus =async (vendorOrderID,paymentLabel,noLoading = false) => {
  try {
    let form = new FormData()
    form.append('vendorOrderID', vendorOrderID)
    form.append('payType', 'lakala')
    let res = await api('v2/jxorder/RefreshPayStatus', {
      method: 'POST',
      data: form,
      noLoading
    })
    return res
  } catch (e) {
    console.error('refreshPayStatus', e)
    throw e
  }
}

/**
 * @description 扫码枪 到店扫码支付订单退款 收获退款 post
 * @Param token           header    string  true  "认证token"
 * @Param vendorOrderID  formData   string  true  "订单ID"
 * @Param skuIds         formData   string  true  "[key:value]退款商品 skuId:count,int"
 * @Param Reason         formData   string  true  "退单原因"
 * 
 * @Param	payType			formData	string	true	"扫码方式[tonglian/lakala]"
 * 
 */
export const refundOnlineOrder  = async (vendorOrderID,skuIds,reason,noLoading = false,payType) => {
  try {
    let form = new FormData()
    form.append('vendorOrderID', vendorOrderID)
    form.append('skuIds', JSON.stringify(skuIds))
    form.append('reason', reason)
    if(payType) form.append('payType', 'lakala')
    let res = await api('v2/jxorder/RefundOnlineOrder', {
      method: 'POST',
      data: form,
      noLoading
    })
    return res
  } catch (e) {
    console.error('refundOnlineOrder', e)
    throw e
  }
}

/**
 * @description 支付宝 扫码枪 注册到通联，每个门店只有一个，要更改，必须先注销
 * @router /TerminalRegister [post]
 * @Param	token			header		string	true	"认证token"
 * @Param	storeId			formData	int		true	"京西门店ID"
 * @Param	operation		formData	string	true	"当前操作00-新增,02-注销"	
 */
export const terminalRegister = async (storeId,operation) => {
  try {
    let form = new FormData()
    form.append('storeId', storeId)
    form.append('operation', operation)
    let res = await api('v2/jxorder/TerminalRegister', {
      method: 'POST',
      data:form
    })
    return res
  } catch (error) {
    throw error
  }
}


/**
 * 扫码订单刷新售后信息
 * @Param	afsOrderId	formData	string	true	售后订单id
 * @Param	payType			formData	string	true	"扫码方式[tl/lkl]"
 */
export const queryBarCodeRefundStatus = async (afsOrderId,payType = 'lakala') => {
  try {
    let form = new FormData()
    form.append('afsOrderId', afsOrderId)
    form.append('payType', payType)
    let res = await api('v2/jxorder/QueryBarCodeRefundStatus', {
      method: 'POST',
      data:form
    })
    return res
  } catch (error) {
    throw error
  }
}


// WEBPACK FOOTER //
// ./src/apis/controls/order.js